import React, { useState, useEffect } from 'react'
import Accordion from 'react-bootstrap/Accordion';
import Select from 'react-select';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Address from './GeneralTabs/Address';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getBranchList } from '../../../../Redux/action/Organisation/Branch/BranchAction';
import Beatloader from '../../../../Common/Loaders/Beatloader';
import MoreAddresses from './GeneralTabs/MoreAddresses';
import AccountManagers from './GeneralTabs/AccountManagers';
import CustomDetails from './GeneralTabs/CustomDetails';
import { getEmployeeList } from '../../../../Redux/action/Organisation/OrganisationListAction';
import { limitString } from '../../../../HelperFunctions';

const GeneralTab = ({ token, user_id, b64id }) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [branch_id, setBranch_id] = useState(0);
    const [branch_country_id, setBranch_country_id] = useState(0);
    const [showLoader, setShowLoader] = useState(false);
    const [branchListing, setBranchListing] = useState([]);
    const [activeTab, setActiveTab] = useState("home"); // State to track the active tab

    const handleGoToFirstTab = () => {
        setActiveTab("home"); // Set the active tab to "home"
    };



    useEffect(() => {
        if (token && user_id && b64id) {
            let id = atob(b64id);
            if (id) {
                dispatch(getBranchList(token, user_id, id))
            }
        }
    }, [token, user_id, b64id]);

    const refresh = () => {
        if (token && user_id && b64id) {
            dispatch(getEmployeeList(token, user_id))
            let id = atob(b64id);
            if (id) {
                dispatch(getBranchList(token, user_id, id))
            }
        }
    };

    const { loadingBranchList, BranchListError, BranchList } = useSelector(state => state?.BranchReducer);
    const { loadingEmployeeList, EmployeeList, EmployeeListError, } = useSelector(state => state?.OrganisationListReducer);

    useEffect(() => {
        if (loadingBranchList) {
            setShowLoader(true)
        } else {
            setShowLoader(false)
        };


        if (BranchList) {
            setBranchListing(BranchList)
        }
    }, [loadingBranchList, BranchListError, BranchList]);



    return (
        <>
            {
                showLoader ?
                    <Beatloader />
                    :
                    <>
                        <div className="row border-bottom-2 pb-3">
                            <div className="col-md-3">
                                <div className="custom-card">
                                    <div className="branch-bg d-flex justify-content-between">
                                        <h4 className="mb-0">
                                            Branches
                                        </h4>
                                        <span title="Add New">
                                            <i
                                                className="ti ti-plus branches-icon-add" onClick={() => { setBranch_id(0); setBranch_country_id(0); handleGoToFirstTab() }}
                                            ></i>
                                        </span>
                                    </div>
                                    {/* <div className="text-center">
                                        <button className="m-1 btn btn-sm btn-danger" onClick={() => { setBranch_id(0); setBranch_country_id(0); handleGoToFirstTab() }}>+Add New</button>
                                    </div> */}
                                    <ul>
                                        {
                                            branchListing.map((val, i) => {
                                                return <li className={`m-2 p-1 org-gen-branch-list ${val.id == branch_id ? "active" : ""}`} key={i + 1} onClick={() => { setBranch_id(val?.id); setBranch_country_id(val?.country) }}>{limitString(val?.branch_name, 20)}</li>
                                            })
                                        }
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-9">
                                <div className="row-gap-2">
                                    <Tabs
                                        activeKey={activeTab} // Controlled by state
                                        onSelect={(k) => setActiveTab(k)} // Update state on tab change
                                        transition={false}
                                        id="noanim-tab-example"
                                        className="nav nav-pills mb-3 custom-tabs gap-0"
                                    >
                                        <Tab eventKey="home" title="Address" className="nav-item">
                                            <Address branch_id={branch_id} token={token} user_id={user_id} b64id={b64id} refresh={refresh} loadingEmployeeList={loadingEmployeeList} EmployeeList={EmployeeList} />
                                        </Tab>
                                        <Tab eventKey="profile" title="More Addressess" className="nav-item" disabled={branch_id ? false : true}>
                                            <MoreAddresses branch_id={branch_id} branch_country_id={branch_country_id} token={token} user_id={user_id} b64id={b64id} refresh={refresh} />
                                        </Tab>
                                        <Tab eventKey="contact" title="Account Managers" className="nav-item" disabled={branch_id ? false : true}>
                                            <AccountManagers branch_id={branch_id} token={token} user_id={user_id} b64id={b64id} refresh={refresh} />
                                        </Tab>
                                        <Tab eventKey="customdetails" title="Custom Details" className="nav-item" disabled={branch_id ? false : true}>
                                            <CustomDetails branch_id={branch_id} token={token} user_id={user_id} b64id={b64id} refresh={refresh} />
                                        </Tab>
                                    </Tabs>
                                </div>
                            </div>
                        </div>

                    </>
            }
        </>

    )
}

export default GeneralTab